﻿const dataState = {
    allQuestions: [],
    titles: [],
    chapters: [],
    error: false,
    formId: '',
    appId: '',
    status: '',
}

const uiState = {
    stop: false,
    loading: false,
}

const statusState = {
    currentProgress: 0
}

const headerState = {
    currentChapterTitle: 'Starta ditt sparande',
}

const contentState = {
    modalContent: ''
}

export const pensionWizardView = (viewState = headerState, action) => {
    switch (action.type) {
        case 'CURRENT_CHAPTER_TITLE':
            return { currentChapterTitle: action.data }
        default:
            return viewState;
    }
}

export const pensionWizardFlow = (wizardState = uiState, action) => {
    switch (action.type) {
        case 'STOP':
            return { stop: action.data }
        case 'LOADING':
            return { loading: action.data }
        default:
        return wizardState;
    }
}

export const pensionWizardProgress = (progressState = statusState, action) => {
    switch (action.type) {
        case 'UPDATE_PROGRESS':
            return { currentProgress: action.data }
        default:
            return progressState;
    }
}


export const pensionWizardModal = (modalState = contentState, action) => {
    switch (action.type) {
        case 'TOGGLE_MODAL_CONTENT':
            return {modalContent: action.data}
        default:
            return modalState;
    }
}


export const pensionWizard = (formState = dataState, action) => {
    switch (action.type) {
        case 'FETCH_MANAGED_PENSION_QUESTIONS':
            return { ...formState, allQuestions: action.data };
        case 'PENSION_WIZARD_FORM_SUBMITTED':
            return { ...formState, ...action.data };
        case 'PENSION_WIZARD_FORM_SUBMIT_FAILED':
            return { ...formState, error: !!action.data };
        case 'CHAPTERS':
            return { ...formState, chapters: action.data };
        case 'CHAPTER_TITLES':
            return { ...formState, titles: action.data };
        case 'QUESTIONS':
            return { ...formState, questions: action.data };
        case "APPID":
            return { appId: action.data };
        case "FORMID":
            return { formId: action.data };
        case "STATUS":
            return { status: action.data };
        default:
            return formState;
    }
}
